import {
    Card,
    CardActionArea,
    CardContent,
    Snackbar,
    Typography,
} from '@mui/material'
import React, {
    ComponentPropsWithRef,
    forwardRef,
    useState,
} from 'react'
import { Assignation } from '../context/types'
import { Icons } from '../assets/icons'
import type { TypographyVariant } from '../types/mui'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import { FadingWraper } from './FadingWraper'
import { ValuePicto } from './ValuePicto'
import { DFType, DynamicFont } from './MTypo/DynamicFont'
import { logException } from '../services/sentryLogger'

// const DELAY_AFTER_LONG_PRESS = 500 * 2.5
// @ts-ignore TS2307
type Props = ComponentPropsWithRef<typeof CardActionArea> &
    Partial<Assignation> & {
        onPickStm?: (id: string) => Promise<void>
        onlyLongPress?: boolean
        onEnter?: (id: string) => void
        onIncrease?: (id: string) => void
        onDecrease?: (id: string) => void
        debug?: boolean
        textSize?: TypographyVariant
        iconSize?: string
        emoji?: boolean
        big?: boolean
        fontType?: DFType
        draggable?: boolean
        showId?: boolean
        showRank?: boolean
        readonly?: boolean
    }

export const StatementCard = forwardRef<typeof Card, Props>((p, ref) => {
    let {
        className,
        style,
        id = '', // FIXME
        index,
        bucket = '',
        title = '-',
        roundNumber,
        onEnter,
        onClick,
        onIncrease,
        onDecrease,
        onPickStm,
        disabled = false,
        category,
        valueKey,
        onlyLongPress = false,
        highlight = false,
        selected = false,
        big = false,
        draggable = highlight,
        debug = false,
        textSize = big ? 'h6' : 'body2',
        emoji = false,
        showId = false,
        showRank = false,
        fontType = big ? 'big' : 'none',
        iconSize,
        readonly = false,
        ...rest // FIXME Warning: React does not recognize the `preferredType`
    } = p

    const hasEmoji = category && emoji

    onClick =
        onClick || !!onPickStm
            ? (e) => {
                  console.debug('onClick STM', {
                      id,
                      hasEmoji,
                      emoji,
                      category,
                      valueKey,
                      title,
                  })
                  // @ts-ignore
                  onPickStm(id)
                      ?.then(() => setSnackTxt(''))
                      ?.catch((e) => logException('StmCard', 'onPick', e))
              }
            : undefined
    disabled = disabled || !onClick

    const t = useTranslation( useCommonCtx())
    const [snackTxt, setSnackTxt] = useState('')

    const fullTitle = (showId ? `(${valueKey}) ` : '') + title // TODO
    let bgValue = 'white' // bg-gray-100
    let textColor = 'text-gray-600'
    if (selected) {
        bgValue = 'bg-gray-200'
        textColor = 'text-white'
    } else if (highlight) {
        bgValue = 'bg-gray-200'
        textColor = 'text-gray-600'
    } else if (readonly) {
        bgValue = 'white'
        textColor = 'text-gray-600'
    }
    // FIXME font-bold causes uppercase
    // FIXME was h-8 for non bug
    const textClass = `text-center ${big ? '' : ''} ${textColor}`
    return (
        <Card
            ref={ref as any}
            sx={{
                display: 'flex',
                flex: '1 1 0%',
                minWidth: big ? 275 : 200,
                borderRadius: 2,
                ...style,
            }}
            className={`${
                readonly ? 'shadow-none' : 'shadow-xl'
            } max-w-screen-lg my-2 ${bgValue} `}
        >
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                // autoHideDuration={DELAY_AFTER_LONG_PRESS}
                open={!!snackTxt}
                onClose={() => setSnackTxt('')}
                message={snackTxt}
                key={'bottomcenter'}
            />
            <CardActionArea
                sx={{
                    // new:
                    // height: '100%', // NOT REQUIRED ANYMORE, causes OVERFLOW (mobile, all height 100pc below)
                    // new:
                    display: 'flex',
                    // new:
                    flex: '1 1 0%',
                    // borderStyle: 'solid',
                    // borderColor: 'black',
                    // borderWidth: '1px',
                    // height: '100%',
                }}
                {...rest}
                onKeyDown={(e: any) => {
                    // FIXME extract
                    console.log('onKeyDown', e.key, !!onEnter)
                    e.preventDefault()
                    e.stopPropagation()
                    if (e.key === 'Enter' && onEnter) {
                        console.log('Enter')
                        onEnter(e)
                    } else {
                        console.log('no Enter')
                    }
                }}
                onClick={onClick}
                disabled={!onClick || disabled}
                {...(showId ? { title: `#${id}` } : {})}
            >
                <CardContent
                    sx={{
                        // new:
                        // height: '100%',
                        display: 'flex',
                        // new:
                        flex: '1 1 0%',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }}
                >
                    <>
                        {draggable && (
                            <Icons.DragIcon
                                sx={{
                                    color:
                                        highlight || selected
                                            ? 'white'
                                            : 'black',
                                    opacity: '0.5',
                                    marginRight: '0.5rem',
                                }}
                            />
                        )}
                        <Typography
                            variant={'caption'}
                            component="div"
                            className={`absolute top-1 left-1 ${textColor}`}
                        >
                            {showRank && `${index}. `}
                        </Typography>
                    </>
                    <FadingWraper
                        style={{
                            width: '100%',
                            // new:
                            height: '100%',
                            // display: 'flex',
                            // flex: '1 1 0%',
                            // backgroundColor: 'red',
                            // flexGrow: 1,
                            // justifyContent: 'center',
                        }}
                        active={draggable && highlight}
                    >
                        <Typography
                            // component="div"
                            // className={`flex ${textClass} ${big ? 'flex-col' : 'flex-row justify-between'} items-center`}
                            className={`flex flex-1 ${textClass} ${
                                !hasEmoji
                                    ? 'justify-center'
                                    : big
                                    ? 'flex-col justify-around'
                                    : 'flex-row justify-between'
                            }  items-center`}
                        >
                            <DynamicFont
                                fontType={!hasEmoji ? 'big' : fontType}
                                textSize={!hasEmoji ? 'h6' : textSize}
                                fullTitle={fullTitle}
                            />
                            {hasEmoji && (
                                <ValuePicto
                                    iconSizePreset='big'
                                    valueKey={valueKey}
                                    // FIXME this prop is never used
                                    iconSize={iconSize}
                                />
                            )}
                        </Typography>
                    </FadingWraper>
                </CardContent>
            </CardActionArea>
        </Card>
    )
})
